import { Typography } from '@material-ui/core'

import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { NumberFieldData } from '../../mockData/inventory'
import { ChannelForAllocatedList } from '../../types/inventoryAllocatedList'
import AllocatedNumberBox from './AllocatedNumberBox'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AllocateChannelRowProps {
  allocatedAvailability: NumberFieldData[]
  channelData: ChannelForAllocatedList
  weekendIndexes: number[]
  propertyCode: string
  roomtypeCode: string
}

const AllocateChannelRow: React.FC<AllocateChannelRowProps> = ({
  allocatedAvailability,
  channelData,
  weekendIndexes,
  propertyCode,
  roomtypeCode
}) => {
  const classes = useStyles()

  const isPersian = persianRegex.test(channelData.basicDetails.name)

  return (
    <>
      <div className={classes.ratePlanRow}>
        <div className={classes.rowNameContainer}>
          <div className={classes.roomIcon} />
          <div className={classes.rowName}>
            <Typography
              variant="h5"
              className={classes.rowNameTitle}
              style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
              {channelData.basicDetails.name}
            </Typography>
          </div>
        </div>
        <div className={classes.dayContainer}>
          <Typography variant="h5">{getTranslate('allocated')}</Typography>
        </div>
        {allocatedAvailability?.map((availItem, index) => (
          <AllocatedNumberBox
            availItem={availItem}
            channelID={channelData.basicDetails.channelID}
            index={index}
            propertyCode={propertyCode}
            roomtypeCode={roomtypeCode}
            weekendIndexes={weekendIndexes}
          />
        ))}
      </div>
    </>
  )
}

export default AllocateChannelRow
